import Swiper from 'swiper/dist/js/swiper'

function initSwiper() {
  const mySwiper = new Swiper('.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 4,
    autoHeight: true,
    loop: true,
    nextButton: '.js-btn-slide-next',
    prevButton: '.js-btn-slide-prev',
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    }
  })
}

function init() {
  initSwiper()
}

export default {
  init
}



// WEBPACK FOOTER //
// ./app/components/swiper/SwiperView.js